import AdminFelvesz from "../components/admin/admin_ugyintezok/AdminFelvesz";
import AdminTablazat from "../components/admin/admin_ugyintezok/AdminTablazat";

function AdminUgyintezok() {
  return (
    <div>
      <AdminFelvesz />
      <AdminTablazat />
    </div>
  );
}

export default AdminUgyintezok;
